import React, { useState } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import get from 'lodash/get';
import { graphql } from '@apollo/react-hoc';
import { fromGlobalId } from 'graphql-relay';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { SimpleLoadingComponent } from '../../utils/apollo';
import Button from '../../components/Button';
import AddTravelPlan from '../../mutations/RepVisitsTravelPlan/addTravelPlan';
import Toast from '../../components/Toast';
import './styles.css';

const messages = defineMessages({
  viewAvailability: {
    id: 'community.check.availability',
    defaultMessage: 'Check Repvisits Availability',
  },
  addToTravelPlan: {
    id: 'repvisits.travel.plan.addHighSchool',
    defaultMessage: 'Add To Travel Plan',
  },
  addedToTravelPlan: {
    id: 'repvisits.travel.plan.successDescription',
    defaultMessage: 'School added to Travel Plan',
  },
});

const RepVisitsAvailability = ({ hasAvailability, closeModal, showAvailabilitySideBar, highschoolId }) => {
  if (!hasAvailability) return null;
  return (
    <Button
      data-cy="availability-button"
      styleName="view-button"
      onClick={() => {
        closeModal();
        showAvailabilitySideBar(fromGlobalId(highschoolId).id);
      }}
    >
      <FormattedMessage {...messages.viewAvailability} />
    </Button>
  );
};

const AddToTravelPlan = ({ isInTravelPlan, addToTravelPlan, highschoolId }) => {
  if (isInTravelPlan) return null;
  return (
    <Button data-cy="travel-plan-button" styleName="view-button" onClick={() => addToTravelPlan(highschoolId)} name="Add to travel plan">
      <FormattedMessage {...messages.addToTravelPlan} />
    </Button>
  );
};

const SuccessToast = ({ intl, show, hideToast }) => (
  <Toast
    data-cy="success-toast"
    active={show}
    title=""
    kind="success"
    description={intl.formatMessage(messages.addedToTravelPlan)}
    onDeactivate={hideToast}
  />
);

export const HighschoolRepVisitsButtons = ({ intl, hsRepVisits, addTravelPlan, closeModal, showAvailabilitySideBar }) => {
  const travelPlan = get(hsRepVisits, 'viewer.repVisitsTravelPlan', []);
  const highschoolId = get(hsRepVisits, 'highSchoolBySchoolId.id', '');
  const hasAvailability = get(hsRepVisits, 'highSchoolBySchoolId.repVisitsAccount.availabilityVisible', false);
  const [showToast, setShowToast] = useState(false);
  const [isInTravelPlan, setInTravelPlan] = useState(false);
  const addToTravelPlan = (highSchoolId) => addTravelPlan({ variables: { input: { highSchoolId } } })
    .then(() => { setInTravelPlan(true); setShowToast(true); });
  /* istanbul ignore next */
  const hideToast = () => setShowToast(false);
  return (
    <div id="highschool-repvisits-buttons" styleName="button-container">
      <RepVisitsAvailability
        highschoolId={highschoolId}
        hasAvailability={hasAvailability}
        closeModal={closeModal}
        showAvailabilitySideBar={showAvailabilitySideBar}
      />
      <AddToTravelPlan
        highschoolId={highschoolId}
        isInTravelPlan={hasAvailability || isInTravelPlan || travelPlan.some((highschool) => highschool.id === highschoolId)}
        addToTravelPlan={addToTravelPlan}
      />
      <SuccessToast intl={intl} show={showToast} hideToast={hideToast} />
    </div>
  );
};

HighschoolRepVisitsButtons.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    formatDate: PropTypes.func.isRequired,
  }).isRequired,
  hsRepVisits: PropTypes.object,
  addTravelPlan: PropTypes.func,
  closeModal: PropTypes.func,
  showAvailabilitySideBar: PropTypes.func,
};

AddToTravelPlan.propTypes = {
  isInTravelPlan: PropTypes.bool,
  addToTravelPlan: PropTypes.func,
  highschoolId: PropTypes.string,
};

RepVisitsAvailability.propTypes = {
  hasAvailability: PropTypes.bool,
  closeModal: PropTypes.func,
  showAvailabilitySideBar: PropTypes.func,
  highschoolId: PropTypes.string,
};

SuccessToast.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    formatDate: PropTypes.func.isRequired,
  }).isRequired,
  show: PropTypes.bool,
  hideToast: PropTypes.func,
};

const hsRepVisitsQuery = gql`
  query HighschoolRepVisits($id: String!) {
    viewer { id repVisitsTravelPlan { id } }
    highSchoolBySchoolId(id: $id) { id repVisitsAccount { availabilityVisible } }
  }  
`;
const hsRepVisits = graphql(hsRepVisitsQuery, { name: 'hsRepVisits', options: ({ params }) => ({ variables: params }) });
const addToTravelPlan = graphql(AddTravelPlan, { name: 'addTravelPlan' });
export default SimpleLoadingComponent(hsRepVisits, addToTravelPlan)(injectIntl(HighschoolRepVisitsButtons));
